// utils/http.js — Handler de error global para los ajax (M10)
//
// Wrapper centralizado sobre $.ajax con success/error manejados de forma consistente:
//   - En éxito: resuelve con los datos.
//   - En error: loguea, llama a opts.onError si existe, y:
//       * si opts.resolveOnError está definido → resuelve con ESE valor (permite a la
//         cadena del home no quedar bloqueada — ver M3/B3);
//       * si no → rechaza con un Error.
//
// @example
//   httpGet('/es/config/count-product', {}, { timeout: 10000, resolveOnError: {} })
//     .then(data => { ... })
import $ from 'jquery';

export let httpGet = (url, data = {}, opts = {}) => new Promise((resolve, reject) => {
    const { timeout = 15000, onError, resolveOnError } = opts;

    $.ajax({
        url,
        data,
        type: 'GET',
        timeout,
        success: (res) => resolve(res),
        error: (xhr, status, error) => {
            console.error(`[httpGet] ${url} — ${status}: ${error}`);
            if (typeof onError === 'function') {
                onError(xhr, status, error);
            }
            if (resolveOnError !== undefined) {
                resolve(resolveOnError);
            } else {
                reject(new Error(`GET ${url} falló: ${status} ${error}`));
            }
        }
    });
});
